import { cloneElement, useContext } from 'react';

import Props from './Props';

const PropsChild = ({ children }: any) => {
  const context = useContext(Props.Context);

  return cloneElement(children, { ...context, ...children.props });
};

export default PropsChild;
